//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Navs from '~/components/my/navs';
import glhHeader from '~/components/public/glh-header';
import NoneLogin from '~/components/public/none-login';
import bindPhoneMixin from '~/mixins/bind-phone.js';

export default {
  components: {
    Navs,
    NoneLogin,
    glhFooter: () => import('~/components/public/glh-footer'),
    glhHeader,
    Login: () => import('~/components/public/login/index'),
    OrderDialog: () => import('~/components/member/order-dialog/index'),
  },
  mixins: [bindPhoneMixin],
  computed: {
    ...mapGetters('user', ['isLogin']),
  },
};
